import ClickOutside from '@/directives/ClickOutside';

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install (Vue) {
    Vue.directive('click-outside', ClickOutside);
  }
}

export default GlobalDirectives
